module.exports = __webpack_public_path__ + "static/media/icon-home-tag1.59d36656.png";